import { inject, Injectable } from '@angular/core';
import { finalize, Observable, of, share, tap } from 'rxjs';

import { CreditUnionWithRole } from '../api/models/credit-union-portal.model';
import { CreditUnionPortalEndpoint } from '../api/services/credit-union-portal-endpoint';
import { UserState } from '../state/user-state';

@Injectable({
  providedIn: 'root',
})
export class CreditUnionsService {
  private readonly creditUnionEndpoint = inject(CreditUnionPortalEndpoint);
  private readonly userState = inject(UserState);

  private request$: Observable<CreditUnionWithRole[]> | null = null;

  // the list is fetched once per session and reused; logout clears it via UserState.clear()
  loadCreditUnions(): Observable<CreditUnionWithRole[]> {
    const cached = this.userState.creditUnions();
    if (cached) return of(cached);

    this.request$ ??= this.creditUnionEndpoint.getCreditUnions().pipe(
      tap(creditUnions => this.userState.setCreditUnions(creditUnions)),
      finalize(() => this.request$ = null),
      share()
    );

    return this.request$;
  }
}
